<template>
  <div>
    <el-button style="margin-bottom: 20px" type="primary" @click="setsu('null')"
      >添加品牌</el-button
    >
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        label="品牌名称"
        align="center"
        prop="name"
      ></el-table-column>
      <el-table-column label="图片" align="center">
        <template slot-scope="scope">
          <img width="50px" height="50px" :src="scope.row.cover" alt="" />
        </template>
      </el-table-column>
      <el-table-column
        label="排序"
        align="center"
        prop="sort"
      ></el-table-column>
      <el-table-column label="操作" align="center" prop="icon" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="UpdateConfigTypeButton(scope.row)"
            >编辑</el-button
          >
          <el-popconfirm
            title="确定删除该品牌吗？"
            @confirm="delHandle(scope.row.id)"
          >
            <el-button type="danger" plain slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    >
    </el-pagination>
    <el-dialog
      title="品牌"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editForm"
        label-width="120px"
        class="demo-editForm"
      >
        <el-form-item label-width="120px" label="名称" prop="name">
          <el-input v-model="editForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label-width="120px" prop="sort" label="排序">
          <el-input v-model="editForm.sort" type="number"></el-input>
        </el-form-item>
        <!-- <el-form-item label="封面(尺寸1:1)" prop="cover" label-width="140px">
					<VploadImg :limit="1" v-bind:file-list="filesd" :multble="false" :type="1" @submitImg="getImg">
					</VploadImg>
				</el-form-item> -->
        <el-form-item
          label="轮播图(尺寸1:1)"
          prop="imgList"
          label-width="140px"
        >
          <VploadImg
            :limit="1"
            v-bind:file-list="fileList"
            :multble="false"
            @submitImg="getImgList"
          >
          </VploadImg>
        </el-form-item>
        <div style="height: 20px"></div>
        <el-form-item align="center">
          <el-button type="primary" @click="submitForm('editForm')"
            >保存</el-button
          >
          <!-- <el-button @click="resetForm('editForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgThree";
export default {
  name: "masslist",
  components: {
    VploadImg,
  },
  data() {
    return {
      searchForm: {},
      shopForm: {},
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      fileList: [],
      editForm: {
        name: "",
        sort: "",
      },
      total: 0,
      size: 10,
      current: 1,
      dialogVisible: false,
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: "请输入数量",
          },
        ],
      },
      id: "",
    };
  },
  created() {
    this.getConfigType();
  },
  methods: {
    delHandle(id) {
      this.$axios
        .post("/admin/brand/delete", {
          id: id,
        })
        .then((res) => {
          this.getConfigType();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },

    setsu() {
      this.id = "";
      this.imgUrl = "";
      this.editForm.name = "";
      this.editForm.sort = 0;

      this.fileList = [];
      this.dialogVisible = true;
    },

    getImgList(url, add) {
      if (add == 1) {
        this.imgUrl = url;
      } else if (add == 0) {
        this.imgUrl = "";
      }
    },

    handleClose() {
      this.dialogVisible = false;
    },

    submitForm() {
      if (this.id) {
        this.$axios
          .post("/admin/brand/upd", {
            id: this.id,
            imgUrl: this.imgUrl,
            name: this.editForm.name,
            sort: this.editForm.sort,
          })
          .then((res) => {
            this.dialogVisible = false;
            this.getConfigType();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      } else {
        this.$axios
          .post("/admin/brand/add", {
            cover: this.imgUrl,
            name: this.editForm.name,
            sort: this.editForm.sort,
          })
          .then((res) => {
            this.dialogVisible = false;
            this.getConfigType();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getConfigType();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getConfigType();
    },

    //获取常量数据配置列表
    getConfigType() {
      this.$axios
        .post("/admin/brand/getBrandList", {
          pageNo: this.current,
          pageSize: this.size,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.size = res.data.size;
          this.current = res.data.current;
          this.total = res.data.total;
        });
    },
    UpdateConfigTypeButton(id) {
      this.id = id.id;
      this.imgUrl = id.cover;
      this.editForm.name = id.name;
      this.editForm.sort = id.sort;
      this.fileList = [];
      var fles = {
        url: id.cover,
      };
      this.fileList.push(fles);
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
